import React from 'react'
import { Document, Page, View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import QRCode from 'qrcode'

const Qrdoc = ({ tractores }) => {

    const generateQRCode = async (text, size) => {

        try {

          return await QRCode.toDataURL(text, { width: size });

        } catch (error) {

          console.error("Error generando QR:", error);
          return null;

        }

    };

    // Estilos del PDF
    const styles = StyleSheet.create({
        page: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 20,
            flexDirection: "column",
        },
        row: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "80%", // Ajusta el ancho de la fila
            marginBottom: 30,
        },
        qrContainer: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
        },
        text: {
            fontSize: 18,
            marginTop: 10,
        },
        qrImage: {
            width: 283.5, // 10 cm en puntos PDF
            height: 283.5,
        },
        smallQrImage: {
            width: 141.75, // 5 cm en puntos PDF
            height: 141.75,
        },
    });

    return (

        <Document>

            {tractores.map((tractor, index) => (

                <Page key={index} size="A4" style={styles.page}>

                    <View style={styles.row}>

                        {/* Código QR de 10x10 cm */}
                        <View style={styles.qrContainer}>
                            <Image src={generateQRCode(tractor.tractor, 283.5)} style={styles.qrImage} />
                            <Text style={styles.text}>{tractor.tractor} (10x10 cm)</Text>
                        </View>

                        {/* Código QR de 5x5 cm */}
                        <View style={styles.qrContainer}>
                            <Image src={generateQRCode(tractor.tractor, 141.75)} style={styles.smallQrImage} />
                            <Text style={styles.text}>{tractor.tractor} (5x5 cm)</Text>
                        </View>
                        
                    </View>

                </Page>

            ))}

        </Document>

    )

}

export default Qrdoc